// Mock data for development/testing
// This file provides mock user data when needed

export const mockUser = {
  id: 'mock-user-id',
  email: 'mock@example.com',
  first_name: 'Mock',
  last_name: 'User',
  role: 'admin'
};

export const mockUsers = {
  admin: {
    id: 'mock-admin-id',
    email: 'admin@example.com',
    first_name: 'Admin',
    last_name: 'User',
    role: 'admin'
  },
  employee: {
    id: 'mock-employee-id',
    email: 'employee@example.com',
    first_name: 'Employee',
    last_name: 'User',
    role: 'employee'
  }
};

